import { render, staticRenderFns } from "./LegislatedCustomBenefits.vue?vue&type=template&id=a39895e4"
import script from "./LegislatedCustomBenefits.vue?vue&type=script&lang=js"
export * from "./LegislatedCustomBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports